"use client";

import Link from "next/link";
import { useCategories } from "@/app/hooks/use-categories";
import { useEffect, useState } from "react";
import { getInformations } from "@/app/lib/api/informations-public";
import { Informations } from "@/app/lib/api/bilgiler";
import React from "react";

export function Footer() {
  const { menuItems } = useCategories();
  const [loading, setLoading] = useState(true);
  const [informations, setInformations] = useState<Informations[]>([]);

  useEffect(() => {
    const fetchInformations = async () => {
      try {
        const results = await getInformations();
        setInformations(results);
      } catch (error) {
        console.error("Error fetching informations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInformations();
  }, []);

  return (
    <footer className="bg-white border-t">
      <div className="container mx-auto py-12 px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Panoramik Albümler */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Panoramik Albümler</h3>
            <ul className="space-y-2">
              {menuItems
                .find((item) => item.href === "/albumler")
                ?.subItems?.map((subItem) => (
                  <li key={subItem.href}>
                    <Link
                      href={subItem.href}
                      className="text-gray-600 hover:text-gray-900 text-sm"
                    >
                      {subItem.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          {/* Kanvas */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Kanvas</h3>
            <ul className="space-y-2">
              {menuItems
                .find((item) => item.href === "/kanvas")
                ?.subItems?.map((subItem) => (
                  <li key={subItem.href}>
                    <Link
                      href={subItem.href}
                      className="text-gray-600 hover:text-gray-900 text-sm"
                    >
                      {subItem.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          {/* Fotoğraf Baskılar */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Fotoğraf Baskılar</h3>
            <ul className="space-y-2">
              {menuItems
                .find((item) => item.href === "/baski")
                ?.subItems?.map((subItem) => (
                  <li key={subItem.href}>
                    <Link
                      href={subItem.href}
                      className="text-gray-600 hover:text-gray-900 text-sm"
                    >
                      {subItem.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          {/* Hediyelik */}
          {/* <div>
            <h3 className="font-semibold text-lg mb-4">Hediyelik</h3>
            <ul className="space-y-2">
              {menuItems
                .find((item) => item.href === "/hediye")
                ?.subItems?.map((subItem) => (
                  <li key={subItem.href}>
                    <Link
                      href={subItem.href}
                      className="text-gray-600 hover:text-gray-900 text-sm"
                    >
                      {subItem.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div> */}

          {/* Bilgi ve İletişim */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Bilgi ve İletişim</h3>
            <ul className="space-y-2">
              {menuItems
                .filter(
                  (item) =>
                    item.href === "/duyurular" ||
                    item.href === "/iletisim" ||
                    item.href === "/hakkimizda"
                )
                .map((item) => (
                  <li key={item.href}>
                    <Link
                      href={item.href}
                      className="text-gray-600 hover:text-gray-900 text-sm"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t text-sm text-gray-600">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <p className="text-center md:text-left mb-4 md:mb-0">© {new Date().getFullYear()} Flas Album. Tüm hakları saklıdır.</p>
            
            <div className="flex flex-wrap justify-center md:justify-end gap-x-1">
              {informations.map((item, index) => (
                <div key={item.id} className="flex items-center">
                  <Link 
                    href={"/bilgiler/" + item.url}
                    className="hover:text-gray-900 transition-colors px-2 py-1"
                  >
                    {item.title}
                  </Link>
                  {index < informations.length - 1 && (
                    <span className="text-gray-400">•</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
